import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getUsers() {
  const data = await apiGet('helper/users');
  useHelperStore().setUsers(data);
}
